/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsStep_2Aliases {
  AUTOCOMPLETE_EXAM_SIDE = 'autocomplete-exam-side',
  AUTOCOMPLETE_PROCEDURES = 'autocomplete-procedures',
  AUTOCOMPLETE_STATE = 'autocomplete-state',
  CARD_AVATAR_WITH_TWO_SUBTITLES = 'card-avatar-with-two-subtitles',
  FETCH_EXAM_SIDE = 'fetch-exam-side',
  FETCH_PROCEDURES = 'fetch-procedures',
  FETCH_STATE = 'fetch-state',
  FIELD_CRM = 'field-crm',
  FIELD_DOCTOR_NAME = 'field-doctor-name',
  FIELD_EXAM_SIDE = 'field-exam-side',
  FIELD_LIST_PROCEDURES = 'field-list-procedures',
  FIELD_PROCEDURES = 'field-procedures',
  FIELD_SCHEDULING_ITEMS = 'field-scheduling-items',
  FIELD_STATE = 'field-state',
  FORM_SCHEDULING_ITEMS = 'form-scheduling-items',
  INPUT_CRM = 'input-crm',
  INPUT_DOCTOR_NAME = 'input-doctor-name',
  LAYOUT_SCHEDULING_ITEMS = 'layout-scheduling-items',
  MAPPER_EXAM_SIDE = 'mapper-exam-side',
  MAPPER_PROCEDURES = 'mapper-procedures',
  MAPPER_STATE = 'mapper-state',
  PANEL_SCHEDULING_ITEMS = 'panel-scheduling-items',
  TEXT_EXAM_SIDE = 'text-exam-side',
  TEXT_PROCEDURES_INSTRUCTION = 'text-procedures-instruction',
  TEXT_STATE = 'text-state',
}
export { PseudonymAppointmentsStep_2Aliases };
